import { action } from '@ember/object';
import Component from '@glimmer/component';

import $ from 'jquery';

import { isEditableElementActive } from 'webapp/utils/html';

import didInsert from 'webapp/modifiers/did-insert';
import willDestroy from 'webapp/modifiers/will-destroy';

interface Args {
	onTrigger: () => void;
}

export default class ActionNewComponent extends Component<Args> {
	@action
	setupView() {
		const that = this;
		// CTRL+ALT+n
		$(window).on('keydown.createNew', function (e) {
			if (!isEditableElementActive() && e.keyCode === 78) {
				that.args.onTrigger();
			}
		});
	}

	@action
	teardownView() {
		$(window).off('keydown.createNew');
	}

	<template>
		<div {{didInsert this.setupView}} {{willDestroy this.teardownView}}></div>
	</template>
}
